/**
 * ScrollToTopButton — bouton "retour en haut" partagé (shared/).
 *
 * Sprint B2 lot 1. Promotion shared/ justifiée par D39 : 2ᵉ consommateur hors
 * dossier (VetProRoot vetpro/ + SessionDashboard sessions/ refactoré Lot 2).
 *
 * Préset fixe aligné au pattern existant SessionDashboard.jsx (seuil 400px,
 * bottom/right 30, taille 56, fond BRAND.blue dark/light, smooth scroll, ↑).
 * Pas de prop de configuration : l'unicité du style est l'invariant attendu
 * pour cohérence visuelle inter-modes (Owner + Pro Vét.).
 *
 * Props :
 *   - darkMode {boolean} : bascule fond #1B77F1 (light) ↔ #4DA6FF (dark),
 *     calé exactement sur l'inline existant de SessionDashboard pour ne pas
 *     introduire de divergence visuelle au moment du refacto Lot 2.
 *
 * Accessibilité : `<button>` natif (role implicite), `type="button"` pour
 * éviter tout submit accidentel dans un form parent, `aria-label` explicite.
 */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const SCROLL_THRESHOLD_PX = 400;

export default function ScrollToTopButton({ darkMode = false }) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > SCROLL_THRESHOLD_PX);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label={t('app.scrollTop')}
      title={t('app.scrollTop')}
      style={{
        position: 'fixed', bottom: '30px', right: '30px',
        width: '56px', height: '56px', borderRadius: '50%',
        background: darkMode ? '#4DA6FF' : '#1B77F1', color: '#fff',
        border: 'none', fontSize: '24px', cursor: 'pointer', zIndex: 1000,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
    >
      ↑
    </button>
  );
}
